import { Textarea } from '@insta-club/ui';

function AddPageFormStep3() {
    return <Textarea name='page_category' label='توضیحات' placeholder='توضیحات پیج خود را وارد کنید' max={200} />;
}

export default AddPageFormStep3;

